import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Status } from '@df/core/status';
import { SearchResult } from '@df/search/search-result';
import { Search } from '@df/search/search.interfaces';
import { BodyClassService } from '@df/ui/body-class.service';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { SearchComponent } from '../../search.component';

@Component({
    selector: 'search-view-input',
    templateUrl: './search-view-input.component.html',
    styleUrls: ['../../search.scss', './search-view-input.component.scss'],
    standalone: true,
    imports: [FormsModule, SizeClassDirective, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchViewInputComponent extends SearchComponent {
    @Input()
    set searchTerm(value: string) {
        if (this._initialized) {
            this._interact = false;
            this._searchTerm = value;
            this.term = value;
        }
    }

    get searchTerm(): string {
        return this._searchTerm;
    }
    private _searchTerm!: string;

    @Input()
    override status = new Status();

    @Output()
    searchTermChange = new EventEmitter<Search.ITerm[]>();

    private _initialized = false;
    private _interact = false;
    protected bodyClassService = inject(BodyClassService);

    get query(): string | undefined {
        if (this._interact) {
            return this.term;
        }

        return undefined;
    }

    set query(value: string | undefined) {
        this.term = value;
    }

    override ngOnInit() {
        this.bodyClassService.add('search-view-input', this);

        super.ngOnInit();

        this._initialized = true;
    }

    override ngOnDestroy(): void {
        this.bodyClassService.remove('search-view-input', this);

        super.ngOnDestroy();
    }

    override reset() {
        this._interact = false;
        this.query = undefined;

        super.reset();
    }

    override handleKeyUp(event: KeyboardEvent): void {
        this._interact = true;

        if (event.key === 'Enter' || event.code === 'Enter') {
            this.handleBlur();

            this.goToSearch();
        }

        this.detectChanges();
    }

    override handleKeyDown(): void {
        this.detectChanges();
    }

    protected override setBodyClass(value: boolean): void {}

    protected override onSearchResult(result: SearchResult | undefined): void {
        // bind result
        this.result = result;

        // update listing
        this.listingUpdate(result);

        // notify
        this.notify(result);

        this.searchTermChange.emit(result?.data?.terms);

        // detect changes
        this.detectChanges();
    }

    override search(): void {
        this.config.options.search.autocomplete = false;

        super.search();
    }
}
